import React from 'react';

import AuthLayout from '../../common/layout/auth/AuthLayout';
import LoginForm from '../../auth/login/LoginForm';
import loginImg from '../../assets/images/tmf-portal-background-optimized.jpg';

const LoginPage = () => (
  <AuthLayout path={loginImg}>
    <LoginForm />
  </AuthLayout>
);

export default LoginPage;
